module.exports = __webpack_public_path__ + "img/149.d879ff6c.jpg";